import ProviderSpecialtyDropdown from './ProviderSpecialtyDropdown'

export default ProviderSpecialtyDropdown
export { DEFAULT_TITLE as SPECIALTIES_TITLE } from './ProviderSpecialtyDropdown'
